import { MultichainActionType } from '@popup/multichain/actions/action-type.enum';
export const NavigationReducer = (state = { stack: [] }, { type, payload }) => {
    var _a;
    switch (type) {
        case MultichainActionType.RESET_NAV:
            return { stack: [], params: null };
        case MultichainActionType.NAVIGATE_TO:
        case MultichainActionType.NAVIGATE_TO_WITH_PARAMS:
            return navigateTo(state, payload);
        case MultichainActionType.GO_BACK: {
            const newStack = state.stack;
            if (newStack.length > 1) {
                newStack[1].previousParams = newStack[0].params;
            }
            newStack.shift();
            return {
                stack: newStack,
            };
        }
        case MultichainActionType.GO_BACK_TO_THEN_NAVIGATE: {
            const newStack = state.stack;
            const goBacktoPage = (_a = payload === null || payload === void 0 ? void 0 : payload.goBackTo) !== null && _a !== void 0 ? _a : newStack[1].currentPage;
            do {
                if (newStack.length > 1) {
                    newStack[1].previousParams = newStack[0].params;
                }
                newStack.shift();
            } while (goBacktoPage !== newStack[0].currentPage);
            return navigateTo({ stack: newStack }, payload);
        }
        default:
            return state;
    }
};
const navigateTo = (state, payload) => {
    let oldStack = state.stack;
    if (payload === null || payload === void 0 ? void 0 : payload.resetStack) {
        oldStack = [];
    }
    if (payload &&
        payload.nextPage &&
        ((state.stack[0] && payload.nextPage !== state.stack[0].currentPage) ||
            !state.stack[0])) {
        // console.log('[TEST] NavigationReducer: Navigating to ', payload.nextPage);		  
        return {
            stack: [
                { currentPage: payload.nextPage, params: payload.params },
                ...oldStack,
            ],
            params: payload.params,
        };
    }
    else {
        return state;
    }
};
